import { getResponseParseService } from 'services/ResponseParseService'
import { makeSpinRequest } from 'services/ServerService'

const name = 'REQUEST-SPIN'

async function execute() {
  const lines = game.models.SpinModel.get().lines
  const action = game.models.ResponseDataModel.get().action
  const response = await makeSpinRequest({
    action: action,
    token: game.models.GameModel.token,
    params: {
      bet: game.models.BetModel.getValue() / game.models.SpinModel.get().lines,
      lines,
    },
    platform: game.models.GameModel.platform,
    m: game.models.GameModel.m,
  })

  getResponseParseService().parse(response)
}

export function getRequestFreeSpinAction() {
  return {
    name,
    execute,
  }
}
